import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("yk_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    const d = e?.response?.data?.detail;
    if (e?.response?.status === 403 && typeof d === "string" && d.includes("lembaga") && !window.location.pathname.startsWith("/login")) {
      localStorage.removeItem("yk_token");
      sessionStorage.setItem("yk_blocked", d);
      window.location.assign("/login");
    }
    return Promise.reject(e);
  },
);

export function errMsg(e, fallback = "Terjadi kesalahan. Coba lagi.") {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}
